import { useState, useEffect } from "react";
import { Title, TitleProps } from "@introist/react-foundation/v2";

export const LoadingTitle = ({ children, ...rest }: TitleProps) => {
  const [dotCount, setDotCount] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setDotCount(prevCount => {
        // Loop from 0 to 3 and back to 0
        if (prevCount >= 3) return 0;
        return prevCount + 1;
      });
    }, 500);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <Title {...rest}>
      {children} {".".repeat(dotCount)}
    </Title>
  );
};
